module.exports = __webpack_public_path__ + "static/media/upl.c05ed796.png";